import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { refreshToken, setToken } from "../../../redux/actions/auth/token";
import { RootState } from "../../../redux/reducers/root";
import { RefreshState } from "../../../redux/reducers/getAuthReducer/refreshReducer";
import { TOKEN_REFRESH } from "../../../redux/actionTypes/actionsTypes";
import { changeModalState } from "../../../redux/actions/modal/modal";
import AmpButton from "../../common/AmpButton/AmpButton";
import { useNavigate } from "react-router-dom";
import "./RefreshUi.css";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import AmpFormError from "../../common/AmpFormError/AmpFormError";
import { setSessionExpiry } from "../../../utils/helperFunction";
import { useTranslation } from "react-i18next";

// Once refresh operation is complete this element is taking out of the dom
export default function RefreshUi() {

    const { t } = useTranslation("landing");

    const [requestSent, setReqSent] = useState(false);
    const [error, setError] = useState(false);
    const timeLeftInSession = setSessionExpiry();
    const [timerem, setTimeRemaining] = useState(timeLeftInSession);
    const [timerStarted, setTimerStarted] = useState(false);

    const refreshState = useSelector((state: RootState) => state.authReducer.refresh as RefreshState)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formatTime = (time: number) => {
        const seconds = Math.floor((time / 1000) % 60);
        const minutes = Math.floor((time / (1000 * 60)) % 60);
        if(timerem <= 0) {
            navigate("/amp/signout");
        }
        return <span>{minutes.toString().padStart(2, "0")}:{seconds.toString().padStart(2, "0")}</span>
    }
    
    useEffect(()=> {

        if(refreshState.message === "Not allowed to access this resource") {
            setError(true);
        } else if(refreshState.token && refreshState.refresh) {
            const token = refreshState.token
            localStorage.setItem("amptoken", token);
            localStorage.setItem("amprefresh", refreshState.refresh);
            localStorage.setItem("sessionExp", refreshState.exp)
            dispatch(setToken(true));
            dispatch({type: TOKEN_REFRESH.RESET})
            dispatch(changeModalState("modal-dismiss"))
        }
    }, [refreshState, dispatch]);

    useEffect( () => {
        if(!timerStarted){
            let timeRemaining = timerem;
            const interval = setInterval(() => {
                if (timeRemaining >= 0){
                    setTimeRemaining(timeRemaining);
                } else {
                    clearInterval(interval);
                    navigate("/amp/signout");
                }
                timeRemaining = timeRemaining - 1000;
            }, 1000);
            setTimerStarted(true);
        }
        // Initial Safety check to just sign the user out if the 
        if(timerem <= 0) {
            navigate("/amp/signout");
        }
    }, [timerStarted, timerem, navigate])

    const triggerRefresh = () => {
        if(!requestSent) {
            const refreshTokenStorage = localStorage.getItem("amprefresh") as string;
            const userProfileId = localStorage.getItem("userProfileId") as string;
            dispatch(refreshToken(userProfileId, refreshTokenStorage));
            setReqSent(true);
        }
    }

    return (
        <AmpLoadingSpinner loading={refreshState.loading}>
        <div className="refresh-parent">
            <div className="refresh-row"><strong>{t("refresh.time-rem")}</strong> {formatTime(timerem)}</div>
            <div className="refresh-row">{t("refresh.2")}</div>
            <div className="refresh-row">{t("refresh.3")}</div>
            <div className="refresh-row">
                <AmpFormError errorMessage={t("refresh.error")} error={error}/>
            </div>
            <div className="refresh-options refresh-row">
                <AmpButton 
                    onClick={() => triggerRefresh()} type={"submit"} text={t("refresh.button")} disabled={error}/>
                <AmpButton 
                    onClick={() => navigate("/amp/signout")} type={"cancel"} text={t("refresh.signout")}/>
            </div>
        </div>
        </AmpLoadingSpinner>
    )
}   